import { t } from "i18next";

import {
  ItemReturnReasonCode,
  ItemReturnSubReasonCode,
} from "~/graphql/graphql-new.gen";

export const itemReturnReasons = [
  {
    id: ItemReturnReasonCode.BetterPrice,
    label: t("item_return_reasons.better_price"),
  },
  {
    id: ItemReturnReasonCode.Claim,
    label: t("item_return_reasons.claim"),
  },
  {
    id: ItemReturnReasonCode.DamagedProduct,
    label: t("item_return_reasons.damaged_product"),
  },
  {
    id: ItemReturnReasonCode.DamagedShipping,
    label: t("item_return_reasons.damaged_shipping"),
  },
  {
    id: ItemReturnReasonCode.Delay,
    label: t("item_return_reasons.delay"),
  },
  {
    id: ItemReturnReasonCode.Description,
    label: t("item_return_reasons.description"),
  },
  {
    id: ItemReturnReasonCode.Picture,
    label: t("item_return_reasons.picture"),
  },
  {
    id: ItemReturnReasonCode.Quality,
    label: t("item_return_reasons.quality"),
  },
  {
    id: ItemReturnReasonCode.Size,
    label: t("item_return_reasons.size"),
  },
  {
    id: ItemReturnReasonCode.Other,
    label: t("item_return_reasons.other"),
  },
  {
    id: ItemReturnReasonCode.WrongArticle,
    label: t("item_return_reasons.wrong_article"),
  },
];

export const itemReturnSubReasons = [
  {
    id: ItemReturnSubReasonCode.BadShape,
    label: t("item_return_sub_reasons.bad_shape"),
  },
  {
    id: ItemReturnSubReasonCode.MultiSize,
    label: t("item_return_sub_reasons.multi_size"),
  },
  {
    id: ItemReturnSubReasonCode.Other,
    label: t("item_return_sub_reasons.other"),
  },
  {
    id: ItemReturnSubReasonCode.TooLarge,
    label: t("item_return_sub_reasons.too_large"),
  },
  {
    id: ItemReturnSubReasonCode.TooLong,
    label: t("item_return_sub_reasons.too_long"),
  },
  {
    id: ItemReturnSubReasonCode.TooShort,
    label: t("item_return_sub_reasons.too_short"),
  },
  {
    id: ItemReturnSubReasonCode.TooTight,
    label: t("item_return_sub_reasons.too_tight"),
  },
];
